import apiService from '@/services/api.service'

let cachedMiddleVersion: string | null | undefined
let loadingPromise: Promise<string | null> | null = null

export async function loadMiddleVersion(): Promise<string | null> {
  if (cachedMiddleVersion !== undefined) {
    return cachedMiddleVersion
  }

  if (!loadingPromise) {
    loadingPromise = apiService.getAppVersion()
      .then((response) => {
        const version = response?.version?.trim()
        cachedMiddleVersion = version || null
        return cachedMiddleVersion
      })
      .catch(() => {
        cachedMiddleVersion = null
        return null
      })
      .finally(() => {
        loadingPromise = null
      })
  }

  return loadingPromise
}
